import { Input } from 'antd';
import React, { useMemo } from 'react';
import Icon, { CloseIcon, EyeIcon, HideEyeIcon } from '../../Icon';
import './styles.scss';
import cn from 'classnames';
import { formatNumber } from 'utilities/stringHelper';

const MyInput = ({
  targetRef,
  className,
  allowClear,
  suffix,
  numericRegex,
  parseNumericRegex,
  isFormatNumber,
  defaultValue,
  ...rest
}) => {
  const handleChange = (e = '') => {
    return rest.onChange?.(typeof e === 'string' ? e : e.target.value);
  };

  const suffixIcon = useMemo(() => {
    if (allowClear && rest.value?.length) {
      return <Icon component={CloseIcon} onClick={handleChange} />;
    }
    return suffix;
  }, [suffix, allowClear, rest.value, rest.onChange]);

  const classNames = useMemo(() => {
    return cn('input-custom my-input-white', className);
  }, [className]);

  const renderInput = useMemo(() => {
    switch (rest.type) {
      case 'password':
        return (
          <Input.Password
            className={classNames}
            {...rest}
            onChange={handleChange}
            suffix={suffixIcon}
            iconRender={(visible) => (visible ? <EyeIcon /> : <HideEyeIcon />)}
          />
        );
      case 'textarea':
        return (
          <Input.TextArea
            className={classNames}
            {...rest}
            onChange={handleChange}
            suffix={suffixIcon}
          />
        );
      default:
        return (
          <Input
            className={classNames}
            {...rest}
            onChange={handleChange}
            suffix={suffixIcon}
            ref={targetRef}
            defaultValue={defaultValue}
          />
        );
    }
  }, [rest]);

  return <div id="my-input">{renderInput}</div>;
};

MyInput.propTypes = {
  // size: PropTypes.string,
  // name: PropTypes.string,
  // type: PropTypes.string,
  // disabled: PropTypes.bool,
  // formatdate: PropTypes.string,
  // pickerdate: PropTypes.string,
  // suffix: PropTypes.node,
};

MyInput.defaultProps = {
  // size: 'large',
  // name: 'email',
  // type: 'text',
  // placeholder: 'Enter',
  // disabled: false,
  // formatdate: 'DD/MM/YYYY',
  // pickerdate: undefined,
  // suffix: undefined,
  numericRegex: /^-?\d*(\.\d*)?$/,
  parseNumericRegex: /,/gi,
  isFormatNumber: false,
};

export default MyInput;

// const localeDate = {
//   lang: {
//     locale: 'en_US',
//     placeholder: 'Select date',
//     rangePlaceholder: ['Start date', 'End date'],
//     today: 'Today',
//     now: 'Now',
//     backToToday: 'Back to today',
//     ok: 'Ok',
//     clear: 'Clear',
//     month: 'Month',
//     year: 'Year',
//     timeSelect: 'Select time',
//     dateSelect: 'Select date',
//     monthSelect: 'Choose a month',
//     yearSelect: 'Choose a year',
//     decadeSelect: 'Choose a decade',
//     yearFormat: 'YYYY',
//     dateFormat: 'M/D/YYYY',
//     dayFormat: 'dd',
//     dateTimeFormat: 'M/D/YYYY HH:mm:ss',
//     monthFormat: 'MMMM',
//     monthBeforeYear: true,
//     previousMonth: 'Previous month (PageUp)',
//     nextMonth: 'Next month (PageDown)',
//     previousYear: 'Last year (Control + left)',
//     nextYear: 'Next year (Control + right)',
//     previousDecade: 'Last decade',
//     nextDecade: 'Next decade',
//     previousCentury: 'Last century',
//     nextCentury: 'Next century',
//   },
//   timePickerLocale: {
//     placeholder: 'Select time',
//   },
//   dateFormat: 'YYYY-MM-DD',
//   dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
//   weekFormat: 'YYYY-wo',
//   monthFormat: 'YYYY-MM',
// };
